<form [formGroup]="form" (ngSubmit)="save()">
  <div class="modal-header">
    <h4 id="create-location-modal" class="modal-title">{{ "Create new location" | translate }}</h4>
    <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <formly-form [fields]="fields" [form]="form"></formly-form>
  </div>

  <div class="modal-footer">
    <button (click)="modal.dismiss()" class="btn btn-outline-secondary" type="button">
      {{ "Cancel" | translate }}
    </button>

    <button
      [class.loading]="(loadingService.loading$ | async) || (!mapReady && !mapError)"
      (click)="save()"
      class="btn btn-primary"
      type="button"
    >
      {{ "Save" | translate }}
    </button>
  </div>
</form>
